import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

const projects = [
  {
    title: "Immigration Area at T3",
    location: "IGI Airport Delhi",
    category: "Interior Finishing",
    area: "3300 Sqmt",
    cost: "7.4 cr. + GST",
    keyElements: [
      "Granite flooring",
      "ACP cladding",
      "Glass work with SS balusters",
      "Ticketing counters",
      "Signages",
    ],
    images: [
      "/projects/slides/slide-27-1.jpeg",
      "/projects/slides/slide-27-2.jpeg",
    ],
  },
  {
    title: "Office Space at ATS Tower",
    location: "IGI Airport Delhi",
    category: "Interior Finishing",
    area: "6500 Sqmt (G+3)",
    cost: "10.38 cr. + GST",
    keyElements: [
      "Veneer cladding with polishing",
      "French wooden frame and glass partition",
      "Modular office furniture",
      "Grid ceiling",
      "Vitrified tiles flooring",
    ],
    images: [
      "/projects/slides/slide-20-2.jpeg",
      "/projects/slides/slide-20-1.jpeg",
      "/projects/slides/slide-21-1.jpg",
      "/projects/slides/slide-22-4.png",
      "/projects/slides/slide-22-2.jpeg",
      "/projects/slides/slide-22-3.jpg",
      "/projects/slides/slide-22-1.png",
    ],
  },
  {
    title: "Office Space at T2",
    location: "IGI Airport Delhi",
    category: "Interior Finishing",
    area: "3200 Sqmt",
    cost: "7.6 cr. + GST",
    keyElements: [
      "Flooring and carpeting",
      "Grid ceiling",
      "French wooden frame and glass partition",
      "Modular office furniture with chairs and storages",
      "Glass doors with frosting",
    ],
    images: [
      "/projects/slides/slide-23-1.png",
      "/projects/slides/slide-24-1.png",
      "/projects/slides/slide-25-2.jpg",
      "/projects/slides/slide-25-1.jpg",
    ],
  },
  {
    title: "Office Space at Digital Bhawan",
    location: "IGI Airport Delhi",
    category: "Interior Finishing",
    area: "3600 Sqmt",
    cost: "8.5 cr. + GST",
    keyElements: [
      "Flooring and carpeting",
      "Grid ceiling",
      "French wooden frame and glass partition",
      "Modular office furniture with chairs and storages",
      "Glass doors with frosting",
    ],
    images: [
      "/projects/slides/slide-26-1.png",
      "/projects/slides/slide-26-2.jpeg",
    ],
  },
  {
    title: "Hindu Temple",
    location: "IGI Airport Delhi",
    category: "Interior Finishing",
    area: "7900 Sqmt",
    cost: "11 cr. + GST",
    keyElements: [
      "Marble flooring with marble inlay works",
      "Waffle ceiling and painting",
    ],
    images: [
      "/projects/slides/slide-19-1.jpeg",
      "/projects/slides/slide-19-2.jpeg",
    ],
  },
  {
    title: "AJ Kitchen",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "100 Sqmt",
    cost: "1 cr. + GST",
    keyElements: [
      "SPC flooring",
      "Corian counter and tables",
      "Texture paint and veneer",
      "PVD coated metal works",
      "MEP services for kitchen and main dining area",
      "Floral ceiling",
    ],
    images: [
      "/projects/slides/slide-07-1.jpeg",
      "/projects/slides/slide-08-1.jpeg",
      "/projects/slides/slide-08-2.jpeg",
    ],
  },
  {
    title: "JCC Office Space",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "230 Sqmt",
    cost: "1.35 cr. + GST",
    keyElements: [
      "Curved gypsum wall with texture paint and shelves with veneer",
      "Fixed furniture with laminate and veneer cladding",
      "Duco paint on MDF fluted panels",
      "Lacquered glass installation with ply backing",
    ],
    images: [
      "/projects/slides/slide-09-1.jpeg",
      "/projects/slides/slide-09-2.jpeg",
    ],
  },
  {
    title: "JCC Entrance Lobby",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "230 Sqmt",
    cost: "1.35 cr. + GST",
    keyElements: [
      "Sunboard artwork",
      "Supply and installation vinyl artwork",
      "Supply and installation of DiNoc film on round pillar",
      "Graphics on wall",
    ],
    images: [
      "/projects/slides/slide-10-1.jpeg",
      "/projects/slides/slide-10-2.jpeg",
    ],
  },
  {
    title: "JCC Workstation Area",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "230 Sqmt",
    cost: "1.35 cr. + GST",
    keyElements: [
      "Linear metal ceiling",
      "Supply and installation of modular furniture",
      "Supply and installation vinyl artwork",
      "Supply and installation of fluted (CNC cut) acoustic panels",
      "Lacquered glass and softboard installation with ply backing",
      "Graphics on wall",
    ],
    images: [
      "/projects/slides/slide-11-1.jpeg",
      "/projects/slides/slide-11-2.jpeg",
    ],
  },
  {
    title: "Office Space",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "230 Sqmt",
    cost: "1.35 cr. + GST",
    keyElements: [
      "Baffle ceiling",
      "Supply and installation of modular furniture",
      "Gypsum partition with glass partition and glass doors",
      "Supply and installation of fluted (CNC cut) acoustic panels",
      "Lacquered glass and softboard installation with ply backing",
      "Graphics on wall",
      "Fixed furniture",
    ],
    images: [
      "/projects/slides/slide-12-1.jpeg",
      "/projects/slides/slide-13-1.jpeg",
      "/projects/slides/slide-13-2.jpeg",
    ],
  },
  {
    title: "Sunglasses Store at Duty Free",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "90 Sqmt",
    cost: "1.2 cr. + GST",
    keyElements: [
      "Curved walls with Corian cladding",
      "Curved shelves with Corian and SS finish metal rods",
      "Curved drawers with Corian cladding",
      "Stretch fabric ceiling light",
    ],
    images: ["/projects/slides/slide-14-1.jpeg"],
  },
  {
    title: "Bon Voyage Store at Duty Free",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "180 Sqmt (2 stores)",
    cost: "2.8 cr. + GST",
    keyElements: [
      "Rafter ceiling",
      "Circular LED suspended lighting",
      "Wall bays and gondolas",
      "Material movement to South West Pier from Dockyard",
    ],
    images: ["/projects/slides/slide-15-1.jpeg"],
  },
  {
    title: "Canteen at Airside",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "440 Sqmt",
    cost: "1.3 cr. + GST",
    keyElements: [],
    images: [
      "/projects/slides/slide-16-1.jpeg",
      "/projects/slides/slide-16-2.jpeg",
      "/projects/slides/slide-16-3.jpeg",
    ],
  },
  {
    title: "Gordon Ramsay at Duty Free",
    location: "CSMIA Mumbai",
    category: "Interior Finishing",
    area: "170 Sqmt",
    cost: "",
    keyElements: [],
    images: [
      "/projects/slides/slide-17-1.jpeg",
      "/projects/slides/slide-17-2.jpeg",
      "/projects/slides/slide-17-3.jpeg",
      "/projects/slides/slide-17-4.jpeg",
    ],
  },
  {
    title: "Custom Office - Ongoing",
    location: "Cargo Terminal - CSMIA Mumbai",
    category: "Interior Finishing",
    area: "3400 Sqmt",
    cost: "8.4 cr. + GST",
    keyElements: [],
    images: [
      "/projects/slides/slide-18-1.png",
      "/projects/slides/slide-18-2.png",
    ],
  },
  {
    title: "Toilet Block",
    location: "Jaipur Airport",
    category: "Interior Finishing",
    area: "",
    cost: "2.2 cr. + GST",
    keyElements: [
      "Flooring",
      "Grid ceiling",
      "ACP cladding",
      "Glass doors with frosting",
      "Wall cladding",
      "Plumbing works",
      "Electrical works",
      "Supply and installation of all fixtures",
    ],
    images: [
      "/projects/slides/slide-28-1.jpeg",
      "/projects/slides/slide-28-2.jpeg",
      "/projects/slides/slide-28-3.jpeg",
      "/projects/slides/slide-28-4.jpeg",
    ],
  },
  {
    title: "Phoolon Wali Gali",
    location: "Lucknow Airport",
    category: "Interior Finishing",
    area: "",
    cost: "1.4 cr. + GST",
    keyElements: [
      "Granite flooring",
      "ACP cladding",
      "Glass work for railing",
      "SS for railing",
    ],
    images: ["/projects/slides/slide-29-1.jpeg"],
  },
];

type LightboxImage = {
  src: string;
  title: string;
  location: string;
};

const ProjectCard = ({
  project,
  index,
  onImageClick,
}: {
  project: (typeof projects)[number];
  index: number;
  onImageClick: (image: LightboxImage) => void;
}) => {
  const heroImage = project.images[0];
  const gallery = project.images.slice(1, 7);

  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.04 }}
      className="group relative overflow-hidden rounded-2xl border border-white/10 bg-neutral-950/90 shadow-[0_28px_90px_rgba(0,0,0,0.45)]">
      <div
        className="absolute inset-0 opacity-60"
        style={{
          backgroundImage:
            "radial-gradient(circle at 0% 0%, rgba(232,1,2,0.24), transparent 38%), radial-gradient(circle at 100% 100%, rgba(255,255,255,0.08), transparent 42%)",
        }}
      />

      <div className="relative p-4 md:p-6">
        <button
          type="button"
          onClick={() =>
            onImageClick({
              src: heroImage,
              title: project.title,
              location: project.location,
            })
          }
          className="relative w-full aspect-[16/9] overflow-hidden rounded-xl border border-white/10 cursor-zoom-in">
          <img
            src={heroImage}
            alt={`${project.title} project`}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />
          <div className="absolute top-4 left-4 bg-white/10 backdrop-blur-md border border-white/20 text-white text-[11px] uppercase tracking-[0.3em] px-3 py-2">
            {project.location}
          </div>
          <div className="absolute left-4 right-4 bottom-4">
            <h3 className="font-serif text-3xl md:text-5xl text-white leading-tight drop-shadow-[0_8px_24px_rgba(0,0,0,0.5)]">
              {project.title}
            </h3>
          </div>
        </button>

        {gallery.length > 0 && (
          <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-3 auto-rows-[108px] md:auto-rows-[128px]">
            {gallery.map((image, imageIndex) => (
              <button
                key={image}
                type="button"
                onClick={() =>
                  onImageClick({
                    src: image,
                    title: project.title,
                    location: project.location,
                  })
                }
                className={`relative overflow-hidden rounded-lg border border-white/10 bg-black/30 ${
                  imageIndex === 0 && gallery.length > 2
                    ? "md:col-span-2 md:row-span-2"
                    : ""
                } cursor-zoom-in`}>
                <img
                  src={image}
                  alt={`${project.title} gallery`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </button>
            ))}
          </div>
        )}
      </div>
    </motion.article>
  );
};

export const ProjectsPage = () => {
  const [selectedImage, setSelectedImage] = useState<LightboxImage | null>(
    null
  );

  useEffect(() => {
    if (!selectedImage) return;

    const onEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setSelectedImage(null);
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onEscape);
    };
  }, [selectedImage]);

  return (
    <div className="bg-neutral-950">
      <section className="pt-32 pb-20 px-6 md:px-12 lg:px-24 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "radial-gradient(circle at top left, #e80102 0%, transparent 40%), radial-gradient(circle at bottom right, #ffffff 0%, transparent 45%)",
          }}
        />
        <div className="max-w-7xl mx-auto relative">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="lg:col-span-7">
              <p className="text-primary text-xs font-semibold tracking-[0.35em] uppercase mb-6">
                Project Portfolio
              </p>
              <h1 className="font-serif text-5xl md:text-6xl text-white mb-6">
                Landmark Builds,
                <span className="block text-neutral-400">
                  Operational Precision.
                </span>
              </h1>
              <p className="text-neutral-400 text-lg leading-relaxed max-w-2xl">
                From airside interiors to mission-critical terminal upgrades,
                Arihant Infracon delivers finished environments with meticulous
                detailing, safety rigor, and on-schedule execution.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="lg:col-span-5">
              <div className="grid grid-cols-2 gap-4">
                {[
                  "/projects/slides/slide-15-1.jpeg",
                  "/projects/slides/slide-22-4.png",
                  "/projects/slides/slide-17-2.jpeg",
                  "/projects/slides/slide-23-1.png",
                ].map((image, index) => (
                  <div
                    key={image}
                    className={`relative overflow-hidden border border-white/10 ${
                      index === 0 ? "col-span-2 aspect-video" : "aspect-4/3"
                    }`}>
                    <img
                      src={image}
                      alt="Project highlight"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
            </motion.div>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-white/80 text-sm">
            {[
              {
                label: "Focus",
                value: "Interior finishing & airside execution",
              },
              { label: "Airports", value: "CSMIA, IGI, Jaipur, Lucknow" },
              { label: "Scale", value: "90–7,900 Sqmt projects" },
            ].map((item) => (
              <div
                key={item.label}
                className="border border-white/10 px-6 py-4 backdrop-blur-sm bg-white/5">
                <p className="text-[10px] tracking-[0.35em] uppercase text-white/50">
                  {item.label}
                </p>
                <p className="mt-2 text-white/80 text-sm">{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative bg-neutral-900 py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.12]"
          style={{
            backgroundImage:
              "linear-gradient(#ffffff1f 1px, transparent 1px), linear-gradient(90deg, #ffffff1f 1px, transparent 1px)",
            backgroundSize: "64px 64px",
          }}
        />
        <div className="max-w-6xl mx-auto relative">
          <div className="mb-14">
            <p className="text-primary text-xs font-semibold tracking-[0.35em] uppercase mb-4">
              Selected Works
            </p>
            <h2 className="font-serif text-4xl md:text-5xl text-white">
              Crafted Spaces Across Critical Terminals
            </h2>
          </div>

          <div className="space-y-16">
            {projects.map((project, index) => (
              <ProjectCard
                key={project.title}
                project={project}
                index={index}
                onImageClick={setSelectedImage}
              />
            ))}
          </div>
        </div>
      </section>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
            className="fixed inset-0 z-[80] bg-black/85 backdrop-blur-sm p-4 md:p-8 flex items-center justify-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.2 }}
              onClick={(event) => event.stopPropagation()}
              className="w-full max-w-6xl">
              <img
                src={selectedImage.src}
                alt={`${selectedImage.title} enlarged`}
                className="w-full max-h-[82vh] object-contain rounded-xl border border-white/20 bg-black/50"
              />
              <div className="mt-4 text-white">
                <p className="text-[11px] uppercase tracking-[0.3em] text-white/65">
                  {selectedImage.location}
                </p>
                <h3 className="mt-2 font-serif text-2xl md:text-3xl">
                  {selectedImage.title}
                </h3>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
